// Grafické podklady MLŽIDLA pro stranu Chytré řízení SUPLA (schválené vizuály značky).
const BASE = 'https://media.base44.com/images/public/6a3ee88c10959cd3588c4d68/';

export const SUPLA_ASSETS = {
  phone: `${BASE}46076e43b_file_00000000c1808210a45ba11a0c237849.png`,
  tablet: `${BASE}866539a3f_file_00000000f02881f4a7a6deaf48f0e2e4.jpg`,
  box: `${BASE}53efcd349_file_00000000b61481f4be13c6fe7e7085e8.jpg`,
  boxTerrace: `${BASE}59405e20f_file_0000000057648210afcc35a63301b444.png`,
  service: `${BASE}878ec3ab8_file_00000000281081f5aec34eaee7db7b49.jpg`,
  plan: `${BASE}faac5307d_file_0000000016e48210a7737f93cfe5eeeb.png`,
};

export const SUPLA_FUNCTIONS = [
  ['Ovládání z aplikace', 'Zapnutí a vypnutí mlžení odkudkoliv.'],
  ['Ruční ON/OFF', 'Okamžité ruční ovládání na jedno kliknutí.'],
  ['Časové programy', 'Provoz dle dne a hodiny, bez obsluhy.'],
  ['Automatizace', 'Reakce na teplotu, počasí a další podmínky.'],
  ['Přehled provozu', 'Spotřeba vody a historie provozu.'],
];